import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
	list: [],
	salutation: null,
	error: "",
	loading: false,
};

// ADD_salutation
export const addSalutation = createAsyncThunk(
	"salutation/addSalutation",
	async (values) => {
		try {
			const { data } = await axios({
				method: "post",
				url: `salutation`,
				data: {
					...values,
				},
			});
			toast.success("Salutation added successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in adding Salutation try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

// DELETE_salutation
export const deleteSalutation = createAsyncThunk(
	"salutation/deleteSalutation ",
	async (id) => {
		try {
			const resp = await axios({
				method: "delete",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `salutation/${id}`,
			});

			toast.success("Salutation deleted successfully!");
			return {
				data: resp.data.id,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in deleting salutation try again");
			console.log(error.message);
		}
	}
);

// salutationS
export const getAllSalutation = createAsyncThunk(
	"salutation/getAllSalutation",
	async () => {
		try {
			const { data } = await axios.get(`salutation`);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

export const updateSalutation = createAsyncThunk(
	"salutation/updateSalutation",
	async ({ id, values }) => {
		try {
			const { data } = await axios({
				method: "put",

				url: `salutation/${id}`,
				data: {
					...values,
				},
			});
			toast.success("Salutation updated successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in updating Salutation try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

const salutationSlice = createSlice({
	name: "salutation",
	initialState,
	reducers: {
		clearSalutation: (state) => {
			state.salutation = null;
		},
	},
	extraReducers: (builder) => {
		// 1) ====== builders for getAllSalutation ======

		builder.addCase(getAllSalutation.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(getAllSalutation.fulfilled, (state, action) => {
			state.loading = false;
			state.list = action.payload;
		});

		builder.addCase(getAllSalutation.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 2) ====== builders for addSalutation  ======

		builder.addCase(addSalutation.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(addSalutation.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(addSalutation.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});




		// 3) ====== builders for salutation ======

		builder.addCase(updateSalutation.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(updateSalutation.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(updateSalutation.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 4) ====== builders for deleteSalutation  ======

		builder.addCase(deleteSalutation.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(deleteSalutation.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(deleteSalutation.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});
	},
});

export default salutationSlice.reducer;
export const { clearSalutation } = salutationSlice.actions;
